import { postRequest } from './requests';

class LogService {
  web = status =>
    new Promise((resolve, reject) => {
      postRequest(`/logging`, { Active: status }, resolve, reject);
    });

  magic = status =>
    new Promise((resolve, reject) => {
      postRequest(`/magic`, { Active: status }, resolve, reject);
    });

  instrumentation = status =>
    new Promise((resolve, reject) => {
      postRequest(`/metrics`, { Active: status }, resolve, reject);
    });

  download = (type, mode) => {
    return `${type === 'web' ? '/logging' : '/magic'}?download=${
      mode === 'inline' ? 'inline' : 'attachment'
    }`;
  };
}

export default new LogService();
